import { render, staticRenderFns } from "./OrderViewDetail.vue?vue&type=template&id=2d15d103&scoped=true&"
import script from "./OrderViewDetail.vue?vue&type=script&lang=js&"
export * from "./OrderViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewDetail.vue?vue&type=style&index=0&id=2d15d103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d15d103",
  null
  
)

export default component.exports